
import BookmarkHelper from '../mixins/bookmarkHelper'

export default {
  mixins: [BookmarkHelper],
  name: 'bookmarkButton',
  props: ['articleData'],
  data: function() {
    return {
      isBookmarked: false,
    }
  },
  created: function() {
    if (this.articleData.loggedIn) {
      this.hasBookmark(
        this.articleData.magazineUrl,
        this.articleData.issueId,
        this.articleData.containerId
      ).then((isBookmarked) => {
        this.isBookmarked = isBookmarked
      })
    }
  },
  methods: {
    addBookmark: function() {
      if (this.articleData.loggedIn) {
        if (!this.isBookmarked) {
          this.createBookmark(
            this.articleData.urlName,
            this.articleData.issueId,
            this.articleData.containerId
          )
            .then(() => { this.isBookmarked = true })
            .catch(console.error)
        } else {
          window.location.href = '/select/bookmarks/'
        }
      }
    }
  }
}
